/**
*made by JokerSora 20190626
animate function ,input such as number / [numbers] /{key:number,key1:number}  
and these final value ,set step function 
*/

function Animate(
    //item
    item,
    //easing,
    easing,
    //startValue
    s,
    //endValue
    e,
    //during
    d,
    stepFun,
    endFun, watch) {
    var that = this;
    this.sDate = new Date();
    this.sValue = s;
    this.during = d;
    this.eValue = e;
    this.stepFun = stepFun;
    this.endFun = endFun;
    this.item = item;
    this.timeId = function () {
        let fn = function (c0, c1) {
            return function () {
                var percent = (new Date - that.sDate) / that.during;
                var stepValue = that.sValue + (that.eValue - that.sValue) * that.easing(percent);
                if (that.stepFun) {
                    if (watch) {
                        if (watch.pause) {
                            watch.s = stepValue;
                            watch.e = e;
                            watch.d = that.during - (new Date - that.sDate);
                            return;
                        }
                        else {
                            that.stepFun(stepValue, that.item);
                        }
                    }
                    else {
                        that.stepFun(stepValue, that.item);
                    }
                }
                if (percent >= 1
                    || (that.eValue < that.sValue ?
                        (stepValue <= that.eValue) :
                        (stepValue >= that.eValue))) {
                    c0();
                    //cancelAnimationFrame(timer);
                    if (that.endFun) {
                        that.endFun(that.eValue, that.item);
                    }
                }
                else {
                    //timer = requestAnimationFrame(fn);
                    c1();
                }
            }
        }
        if (window.requestAnimationFrame) {
            //利用requestAnimationFrame
            let f = fn(function () {
                cancelAnimationFrame(timer);
            }, function () {
                timer = requestAnimationFrame(f);
            });
            var timer = requestAnimationFrame(f);
        }
        else {
            //利用setTimeOut
            let f = fn(function () { clearTimeout(timer); }, function () { timer = setTimeout(f, 16); });
            var timer = setTimeout(f, 16);
        }

        ////利用setInterval
        //var intval = setInterval(function () {
        //    var percent = (new Date - that.sDate) / that.during;
        //    var stepValue = that.sValue + (that.eValue - that.sValue) * that.tween[easing||"base"](percent);
        //    if (that.stepFun) {
        //        that.stepFun(stepValue, that.item);
        //    }
        //    if (percent >= 1 || (that.eValue < that.sValue ? 
        //                (stepValue <= that.eValue) : 
        //                (stepValue >= that.eValue))) {
        //        clearInterval(intval);
        //        if (that.endFun) {
        //            that.endFun(that.eValue, that.item);
        //        }
        //    }
        //}, 10);
    };
    this.tween = {
        base: function (pos) {
            return pos;
        },
        easeInQuad: function (pos) {
            return Math.pow(pos, 2);
        },

        easeOutQuad: function (pos) {
            return -(Math.pow((pos - 1), 2) - 1);
        },

        easeInOutQuad: function (pos) {
            if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 2);
            return -0.5 * ((pos -= 2) * pos - 2);
        },

        easeInCubic: function (pos) {
            return Math.pow(pos, 3);
        },

        easeOutCubic: function (pos) {
            return (Math.pow((pos - 1), 3) + 1);
        },

        easeInOutCubic: function (pos) {
            if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 3);
            return 0.5 * (Math.pow((pos - 2), 3) + 2);
        },

        easeInQuart: function (pos) {
            return Math.pow(pos, 4);
        },

        easeOutQuart: function (pos) {
            return -(Math.pow((pos - 1), 4) - 1)
        },

        easeInOutQuart: function (pos) {
            if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 4);
            return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
        },

        easeInQuint: function (pos) {
            return Math.pow(pos, 5);
        },

        easeOutQuint: function (pos) {
            return (Math.pow((pos - 1), 5) + 1);
        },

        easeInOutQuint: function (pos) {
            if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 5);
            return 0.5 * (Math.pow((pos - 2), 5) + 2);
        },

        easeInSine: function (pos) {
            return -Math.cos(pos * (Math.PI / 2)) + 1;
        },

        easeOutSine: function (pos) {
            return Math.sin(pos * (Math.PI / 2));
        },

        easeInOutSine: function (pos) {
            return (-.5 * (Math.cos(Math.PI * pos) - 1));
        },

        easeInExpo: function (pos) {
            return (pos == 0) ? 0 : Math.pow(2, 10 * (pos - 1));
        },

        easeOutExpo: function (pos) {
            return (pos == 1) ? 1 : -Math.pow(2, -10 * pos) + 1;
        },

        easeInOutExpo: function (pos) {
            if (pos == 0) return 0;
            if (pos == 1) return 1;
            if ((pos /= 0.5) < 1) return 0.5 * Math.pow(2, 10 * (pos - 1));
            return 0.5 * (-Math.pow(2, -10 * --pos) + 2);
        },

        easeInCirc: function (pos) {
            return -(Math.sqrt(1 - (pos * pos)) - 1);
        },

        easeOutCirc: function (pos) {
            return Math.sqrt(1 - Math.pow((pos - 1), 2))
        },

        easeInOutCirc: function (pos) {
            if ((pos /= 0.5) < 1) return -0.5 * (Math.sqrt(1 - pos * pos) - 1);
            return 0.5 * (Math.sqrt(1 - (pos -= 2) * pos) + 1);
        },

        easeOutBounce: function (pos) {
            if ((pos) < (1 / 2.75)) {
                return (7.5625 * pos * pos);
            } else if (pos < (2 / 2.75)) {
                return (7.5625 * (pos -= (1.5 / 2.75)) * pos + .75);
            } else if (pos < (2.5 / 2.75)) {
                return (7.5625 * (pos -= (2.25 / 2.75)) * pos + .9375);
            } else {
                return (7.5625 * (pos -= (2.625 / 2.75)) * pos + .984375);
            }
        },

        easeInBack: function (pos) {
            var s = 1.70158;
            return (pos) * pos * ((s + 1) * pos - s);
        },

        easeOutBack: function (pos) {
            var s = 1.70158;
            return (pos = pos - 1) * pos * ((s + 1) * pos + s) + 1;
        },

        easeInOutBack: function (pos) {
            var s = 1.70158;
            if ((pos /= 0.5) < 1) return 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s));
            return 0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
        },

        elastic: function (pos) {
            return -1 * Math.pow(4, -8 * pos) * Math.sin((pos * 6 - 1) * (2 * Math.PI) / 2) + 1;
        },

        swingFromTo: function (pos) {
            var s = 1.70158;
            return ((pos /= 0.5) < 1) ? 0.5 * (pos * pos * (((s *= (1.525)) + 1) * pos - s)) :
                0.5 * ((pos -= 2) * pos * (((s *= (1.525)) + 1) * pos + s) + 2);
        },

        swingFrom: function (pos) {
            var s = 1.70158;
            return pos * pos * ((s + 1) * pos - s);
        },

        swingTo: function (pos) {
            var s = 1.70158;
            return (pos -= 1) * pos * ((s + 1) * pos + s) + 1;
        },

        bounce: function (pos) {
            if (pos < (1 / 2.75)) {
                return (7.5625 * pos * pos);
            } else if (pos < (2 / 2.75)) {
                return (7.5625 * (pos -= (1.5 / 2.75)) * pos + .75);
            } else if (pos < (2.5 / 2.75)) {
                return (7.5625 * (pos -= (2.25 / 2.75)) * pos + .9375);
            } else {
                return (7.5625 * (pos -= (2.625 / 2.75)) * pos + .984375);
            }
        },

        bouncePast: function (pos) {
            if (pos < (1 / 2.75)) {
                return (7.5625 * pos * pos);
            } else if (pos < (2 / 2.75)) {
                return 2 - (7.5625 * (pos -= (1.5 / 2.75)) * pos + .75);
            } else if (pos < (2.5 / 2.75)) {
                return 2 - (7.5625 * (pos -= (2.25 / 2.75)) * pos + .9375);
            } else {
                return 2 - (7.5625 * (pos -= (2.625 / 2.75)) * pos + .984375);
            }
        },

        easeFromTo: function (pos) {
            if ((pos /= 0.5) < 1) return 0.5 * Math.pow(pos, 4);
            return -0.5 * ((pos -= 2) * Math.pow(pos, 3) - 2);
        },

        easeFrom: function (pos) {
            return Math.pow(pos, 4);
        },

        easeTo: function (pos) {
            return Math.pow(pos, 0.25);
        },

        linear: function (pos) {
            return pos
        },

        sinusoidal: function (pos) {
            return (-Math.cos(pos * Math.PI) / 2) + 0.5;
        },

        reverse: function (pos) {
            return 1 - pos;
        },

        mirror: function (pos, transition) {
            transition = transition || tween.sinusoidal;
            if (pos < 0.5)
                return transition(pos * 2);
            else
                return transition(1 - (pos - 0.5) * 2);
        },

        flicker: function (pos) {
            var pos = pos + (Math.random() - 0.5) / 5;
            return tween.sinusoidal(pos < 0 ? 0 : pos > 1 ? 1 : pos);
        },

        wobble: function (pos) {
            return (-Math.cos(pos * Math.PI * (9 * pos)) / 2) + 0.5;
        },

        pulse: function (pos, pulses) {
            return (-Math.cos((pos * ((pulses || 5) - .5) * 2) * Math.PI) / 2) + .5;
        },

        blink: function (pos, blinks) {
            return Math.round(pos * (blinks || 5)) % 2;
        },

        spring: function (pos) {
            return 1 - (Math.cos(pos * 4.5 * Math.PI) * Math.exp(-pos * 6));
        },

        none: function (pos) {
            return 0
        },

        full: function (pos) {
            return 1
        }
    };
    this.easing = typeof (easing) === 'function' ? easing : this.tween[easing || 'easeOutQuad'];
}
function myanimate(
    //startValue
    s,
    //endValue
    e,
    //during
    d,
    //easing
    easing,
    stepFun,
    endFun,
    watch) {
    if (watch) {
        if (JSON.stringify(watch) == '{}') {
            let obj = { pause: 0 }
            watch = Object.defineProperty(obj, 'pause', {
                configurable: true,
                enumerable: true,
                get: function () {
                    return this._pause || 0;
                },
                set: function (n) {
                    obj._pause = n;
                }
            })
        }
        else {
            if (watch.pause == 1) {
                s = watch.s;
                e = watch.e;
                d = watch.d;
                delete watch.s;
                delete watch.e;
                delete watch.d;
                watch.pause = 0;
            }
        }
    }
    if (Object.prototype.toString.call(s) == "[object Array]"
        && Object.prototype.toString.call(e) == "[object Array]") {
        if (s.length == e.length && s.length > 0) {
            var stepArr = [];
            var animateFuns = [];
            for (var i = 0; i < s.length; i++) {
                var animate = new Animate(i, easing, s[i], e[i], d, function (v, i) {
                    stepArr[i] = v;
                    if (stepArr.length == s.length && stepFun) {
                        stepFun(stepArr, i);
                    }
                }, function (v, i) {
                    stepArr[i] = v;
                    if (stepArr.length == s.length && endFun) {
                        endFun(stepArr, i);
                    }
                }, watch);
                animateFuns.push(animate);
            }
            for (var i = 0; i < animateFuns.length; i++) {
                animateFuns[i].timeId();
            }
        }
    }
    else if (Object.prototype.toString.call(s) == "[object Object]"
        && Object.prototype.toString.call(e) == "[object Object]") {
        var props = [];
        for (var sProp in s) {
            for (var eProp in e) {
                if (sProp === eProp) {
                    props.push(sProp);
                }
            }
        }
        if (props.length > 0) {
            var stepObj = {};
            var animateFuns = [];
            for (var i = 0; i < props.length; i++) {
                var prop = props[i];
                var animate = new Animate(prop, easing, s[props[i]], e[props[i]], d, function (v, prop) {
                    stepObj[prop] = v;
                    var num = 0;
                    for (var i in stepObj) {
                        num++
                    }
                    if (num == props.length && stepFun) {
                        stepFun(stepObj, prop);
                    }
                }, function (v, prop) {
                    stepObj[prop] = v;
                    var num = 0;
                    for (var i in stepObj) {
                        num++
                    }
                    if (num == props.length && endFun) {
                        endFun(stepObj, prop);
                    }
                }, watch);
                animateFuns.push(animate);
            }
            for (var i = 0; i < animateFuns.length; i++) {
                animateFuns[i].timeId();
            }
        }
    }
    else {
        var animate = new Animate(null, easing, s, e, d, stepFun, endFun, watch);
        animate.timeId();
    }
    return watch;
}

export default myanimate;